import styled from 'styled-components';

export const CheckDeliveryTime = styled.div`
  background-image: linear-gradient(to bottom, #fbefdf, #fff);
  margin: 20px 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  max-width: 400px;
  color: rgba(0, 0, 0, 0.7);
  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  padding: 15px;

  .pincodeContainer {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 10px 0;

    .addressDetails {
      color: #000;
      font-weight: 500;
      font-family: 'Montserrat';
      font-size: 16px;

      p {
        padding: 9px 0 2px 0;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.7);
        text-transform: uppercase;
      }
    }

    .pincodeInput {
      display: flex;
      justify-content: space-between;
      align-items: start;
    }

    .errorMessage {
      color: red;
      font-family: 'Montserrat';
      font-weight: 500;
      font-size: 12px;
    }

    input {
      width: 60%;
      background: none;
      border: none;
      border-bottom: 1px solid rgba(0, 0, 0, 0.8);
      color: rgba(0, 0, 0, 0.8);
      margin-right: 45px;
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      outline: none;
      padding: 5px;
    }

    input::placeholder {
      color: rgba(0, 0, 0, 0.8);
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 14px;
    }

    input:focus::placeholder {
      color: transparent;
    }

    button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: white;
      border: 2px solid #ef4e5e;
      border-radius: 8px;
      color: #ef4e5e;
      padding: 6px 20px;
      font-family: 'Montserrat';
      font-weight: bold;
      cursor: pointer;

      img {
        margin-left: 10px;
        width: 16px;
        height: 16px;
      }
    }
  }

  .deliveryTimeContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }

  .deliveryTime {
    margin: 10px 0;
    font-family: 'Montserrat';
    color: #000;
    font-weight: 500;
    span {
      color: green;
      font-weight: bold;
      font-size: 14px;
    }
  }

  .orderTimer {
    color: #000;
    margin-top: 10px;
    font-weight: normal;
    font-family: 'Montserrat';
    span {
      color: purple;
      font-weight: bold;
      font-size: 14px;
    }
  }
`;
